import { Controller } from "@hotwired/stimulus"

// The option map's line counting where its options go (review/_option_map): "2 into Frost Claw · 2 into Ember
// Fang", the kept figure first, counted afresh as a tile changes. A place's data-sum says where.
export default class extends Controller {
  static targets = ["line"]
  static values = { kept: String }

  connect() { this.count() }

  count() {
    const counts = new Map([[this.keptValue, 0]])
    this.element.querySelectorAll("input[type=radio]:checked").forEach(input => {
      const where = input.dataset.sum || "another figure"
      counts.set(where, (counts.get(where) || 0) + 1)
    })
    const parts = [...counts].filter(([, n]) => n > 0).map(([where, n]) => `${n} into ${where}`)
    this.lineTarget.textContent = parts.join(" · ")
  }
}
